import {Platform} from "../data/entities/PlatformEntity";
import queryString from "query-string";

export const loadScript = function (url: string, timeoutMs: number = 10000): Promise<any> {
    return new Promise((resolve, reject) => {
        let script: HTMLScriptElement = document.createElement("script");
        let scripts = document.getElementsByTagName("script");
        let prior = scripts[scripts.length - 1];
        script.async = true;
        prior.parentNode && prior.parentNode.insertBefore(script, prior);

        let resolved = false;
        let timeout: ReturnType<typeof setTimeout> = setTimeout(() => {
            if (!resolved) {
                reject();
            }
        }, timeoutMs);

        script.onload = () => {
            resolved = true;
            clearTimeout(timeout);
            resolve();
        };

        script.src = url;
    });
};

export const scrollToElement = (elementId: string) => {
    const element = document.getElementById(elementId);

    if (element) {
        const navOffset = 70;
        const elementPosition = element.getBoundingClientRect().top - document.body.getBoundingClientRect().top - navOffset;

        window.scrollTo({
            top: elementPosition,
            behavior: "smooth"
        });
    }
};

export const getPlatform = (): Platform => {
    let platform: Platform = "web";
    const parsedQueryString = queryString.parse(window.location.search);

    if (parsedQueryString["platform"]) {
        switch (parsedQueryString["platform"]) {
            case "upc":
                platform = "upc";
                break;

            case "upc_steam":
                platform = "upc_steam";
                break;

            case "web":
            default:
                platform = "web";
                break;
        }
    }

    return platform;
}